import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {CreateOrder} from '../classes/CreateOrder';
import {Order} from '../classes/Order';
import {environment} from '../../environments/environment';
import {OrdersView} from '../enums/OrdersView';
import {AdminOrder} from '../classes/AdminOrder';
import {OrderStatus} from '../enums/OrderStatus';
import {Page} from '../classes/Page';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};

@Injectable({
  providedIn: 'root',
})
export class OrderService {

  constructor(private httpClient: HttpClient) {
  }

  public getOrders(ordersView: OrdersView): Observable<Order[]> {

    const options = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      params: new HttpParams().append('view', ordersView)
    };

    return this.httpClient.get<Order[]>(`${environment.backendApiUrl}/v1/orders`, options);
  }

  public createOrder(order: CreateOrder): Observable<any> {
    return this.httpClient.post(`${environment.backendApiUrl}/v1/orders`, {
      officeId: order.officeId,
      roomId: order.roomId,
      bookingOption: order.bookingOption,
      workPlaceName: order.workPlaceName,
      startTime: order.startTime,
      endTime: order.endTime,
      couponId: order.couponId,
      confirmed: order.confirmed,
      monthSubscribe: order.monthSubscribe,
      userId: order.userId
    }, httpOptions);
  }

  public cancelOrder(id: number): Observable<any> {
    return this.httpClient.get(`${environment.backendApiUrl}/v1/orders/cancel?id=` + id);
  }

  public cancelOrderMonthSubscribe(id: number): Observable<any> {
    return this.httpClient.get(`${environment.backendApiUrl}/v1/orders/subscribe/cancel?id=` + id);
  }

  public getQrCode(id: number): Observable<any> {
    return this.httpClient.get(`${environment.backendApiUrl}/v1/orders/` + id + '/qr');
  }

  // TODO move it to the special service for admin operations
  public getAllOrders(startDate: Date,
                      endDate: Date,
                      orderStatus: OrderStatus,
                      pageNumber: number,
                      pageSize: number): Observable<Page<AdminOrder>> {
    return this.httpClient.post<Page<AdminOrder>>(
      `${environment.backendApiUrl}/v1/admin/orders`,
      { startDate, endDate, orderStatus, pageNumber, pageSize },
      httpOptions
    );
  }

  public sendToMonday(id): Observable<void> {
    return this.httpClient.get<void>(
      `${environment.backendApiUrl}/v1/admin/orders/${id}/monday`, httpOptions
    );
  }
}
